import React from 'react';
//Components
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import Button from 'Components/Button';

const DeleteContact = (props) => {
  //Props
  const { messages, onShow, onClose, contact, loading } = props;

  return (
    <Modal
      size={'small'}
      loading={loading}
      open={onShow}
      handleClose={onClose}
      title={`${messages['accountContacts_deleteContact']} "${contact?.title}"`}
    >
      <ModalBody>
        <div style={{ padding: '0px 25px' }}>
          <p style={{ overflowWrap: 'anywhere' }}>
            {`${messages['accountContacts_messageDelete']} "${contact?.title}"?`}
          </p>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          id={'btn-cancel-vehicle'}
          type="button"
          onClick={onClose}
          className="btn-cancel"
        >
          {messages['cancel']}
        </Button>

        <Button
          id={'btn-schedule'}
          type="button"
          onClick={() => onClose(true)}
          className="btn-red"
        >
          {messages['delete']}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteContact;